import React, { useState } from 'react';
import type { ViewAnnotation } from './cmx-document-content-adapter';
import { CmxDocumentContentBody } from './cmx-document-content-body';
import './styles/section-viewer.scss';

export type SectionCardProps = {
  title: string;
  bodyMarkdown: string;
  /**
   * Annotations to highlight inside this card. Empty until CDMX-20063 wires
   * span annotation into the sectioned viewer.
   */
  annotations?: ViewAnnotation[];
  /** The body's media type, passed through to CmxDocumentContentBody. */
  mediaType?: string;
  /** Collapsed on first render. */
  initiallyCollapsed?: boolean;
};

export const SectionCard: React.FC<SectionCardProps> = ({
  title,
  bodyMarkdown,
  annotations,
  mediaType,
  initiallyCollapsed = false
}) => {
  const [collapsed, setCollapsed] = useState(initiallyCollapsed);
  const hasBody = bodyMarkdown.trim().length > 0;

  const cardClass = [
    'cmx-document-content-section-card',
    collapsed ? 'cmx-document-content-section-card--collapsed' : ''
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={cardClass}>
      <button
        type="button"
        className="cmx-document-content-section-card__header"
        aria-expanded={!collapsed}
        onClick={() => setCollapsed((prev) => !prev)}
      >
        <span className="cmx-document-content-section-card__chevron" aria-hidden>
          {collapsed ? '▸' : '▾'}
        </span>
        <span className="cmx-document-content-section-card__title">{title}</span>
      </button>
      {!collapsed && (
        <div className="cmx-document-content-section-card__body">
          {hasBody ? (
            <CmxDocumentContentBody
              text={bodyMarkdown}
              annotations={annotations}
              mediaType={mediaType}
            />
          ) : (
            <div className="cmx-document-content-section-card__empty">
              Header only — no body content
            </div>
          )}
        </div>
      )}
    </div>
  );
};
